import React from 'react'

const HeaderSocials = () => {
    return (
        <div className="home_socials">
            <a href='https://www.instagram.com/aidanharries/' className='home_social-link'>
                <i className="icon-social-instagram"></i>
            </a>

            <a href='https://www.linkedin.com/in/aidan-harries/' className='home_social-link'>
                <i className="icon-social-linkedin"></i>
            </a>

            <a href='https://github.com/aidanharries' className='home_social-link'>
                <i className="icon-social-github"></i>
            </a>
        </div>
    )
}

export default HeaderSocials